import type { SVGProps } from 'react'
const SvgApprove = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.55123 9.51552L14.1897 0.877021C14.3384 0.728187 14.5124 0.652187 14.7117 0.649021C14.9111 0.645854 15.0883 0.721854 15.2435 0.877021C15.3986 1.03219 15.4762 1.21035 15.4762 1.41152C15.4762 1.61285 15.3986 1.7911 15.2435 1.94627L6.18398 11.0213C6.00314 11.2019 5.79223 11.2923 5.55123 11.2923C5.31023 11.2923 5.09931 11.2019 4.91848 11.0213L0.743477 6.84627C0.594811 6.69744 0.521477 6.52077 0.523477 6.31627C0.525311 6.11194 0.603811 5.93219 0.758977 5.77702C0.914144 5.62185 1.09231 5.54427 1.29348 5.54427C1.49481 5.54427 1.67306 5.62185 1.82823 5.77702L5.55123 9.51552Z"
      fill="#2F2F2F"
    />
  </svg>
)

export default SvgApprove
